<main class="app-shell"
  [style.font-family]="appFont + ', \'Helvetica Neue\', Helvetica, Arial, sans-serif'"
  [class]="visibilityAreaClasses$ | async">
  <od-background [asset]="(backgroundAsset$ | async) ?? noneBackgroundAsset"></od-background>
  <router-outlet #outlet="outlet">
  </router-outlet>

  <od-app-backdrop></od-app-backdrop>

  @if (((loading$ | async) || (themeLoading$ | async))) {
    <od-global-spinner></od-global-spinner>
  }
</main>
